export const SUPPORTED_TYPES = [
  'NOTE',
  'PHONE_CALL',
  'SMS',
  'LAB_ORDER_NOTE',
  'BURNOUT',
  'GAD7',
  'PHQ9',
  'WPAI',
  'MISSED_INTAKE_CALL',
  'CHECK_IN_CALL',
  'INTAKE_NOTE',
  'INTAKE_NOTE_PSYCHIATRY',
  'TREATMENT_PLAN',
  'DISCHARGE_SUMMARY_NOTE',
  'FINANCIAL_ELIGIBILITY_CONFIRMED',
  'FINANCIAL_ELIGIBILITY_HEALTH_PLAN',
  'WHO5',
  'INTAKE_NOTE_COACHING',
  'ADVANCED_FOLLOW_UP_NOTE',
  'MONTHLY_SUMMARY_NOTE',
  'TREATMENT_PLAN_COMPREHENSIVE',
  'TREATMENT_PLAN_COMPREHENSIVE_UPDATE',
  'INTAKE_NOTE_COMPREHENSIVE',
]
